import React, { FC, useEffect } from 'react';
import Image from 'next/image';
import { toEnglishNumber } from '@mofid-securities/uikit';
import { classnames } from '@/utils/classnames';
// import { Spinner } from '@/components/Loading';
import { range } from '@/utils/object';

export interface IPasscodeButtonsProps {
  value: string;
  length: number;
  isLoading: boolean;
  onChange: (__value: string) => void;
  onAuthenticatorClick?: () => void;
}

const PasscodeButtons: FC<IPasscodeButtonsProps> = ({
  value = '',
  length,
  onChange,
  isLoading = false,
  onAuthenticatorClick,
}) => {
  const handleAddNumber = (number: number) => {
    if (value.length < length) onChange?.(`${value}${number}`);
  };

  const handleRemoveNumber = () => {
    if (value.length > 0) onChange?.(`${value}`.slice(0, value.length - 1));
  };

  const handleKeyPress = (event: KeyboardEvent) => {
    // convert persian and arabic numbers to english
    const convertedKey = toEnglishNumber(event.key);

    // detect single digits
    if (/^\d$/.test(convertedKey)) {
      handleAddNumber(Number(convertedKey));
    } else if (event.key === 'Backspace') {
      // handle number removal
      handleRemoveNumber();
    }
  };

  useEffect(() => {
    // Add event listener for 'keydown' event
    window.addEventListener('keydown', handleKeyPress);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
    // Keep the latest value to ensure it's accessible in event handlers across re-renders
  }, [value]);

  return (
    <div
      className={classnames(
        'relative',
        isLoading && '!pointer-events-none !opacity-[0.4]'
      )}
    >
      {/*{isLoading && (*/}
      {/*  <Spinner*/}
      {/*    className="absolute left-0 right-0 top-0 bottom-0 m-auto"*/}
      {/*    size="50px"*/}
      {/*  />*/}
      {/*)}*/}

      <div className="flex w-[248px] flex-wrap justify-end gap-[28px] ltr children:cursor-pointer">
        {range(1, 9).map((number) => (
          <PasscodeButton key={number} onClick={() => handleAddNumber(number)}>
            {number}
          </PasscodeButton>
        ))}
        {!!onAuthenticatorClick && (
          <PasscodeButton outline onClick={onAuthenticatorClick}>
            <Image
              alt="اثر انگشت"
              height={28}
              src="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/fingerprint.webp"
              width={24}
            />
          </PasscodeButton>
        )}
        <PasscodeButton onClick={() => handleAddNumber(0)}>0</PasscodeButton>
        <PasscodeButton outline onClick={() => handleRemoveNumber()}>
          <Image
            alt="Error"
            height={22}
            src="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/back-input.webp"
            width={27}
          />
        </PasscodeButton>
      </div>
    </div>
  );
};

export default PasscodeButtons;

const PasscodeButton: FC<
  JSX.IntrinsicElements['button'] & {
    outline?: boolean;
  }
> = ({ className = '', outline = false, ...props }) => (
  <button
    className={classnames(
      `flex h-[64px] w-[64px] select-none items-center justify-center rounded-[16px] text-2xl font-medium text-blue-50`,
      outline
        ? 'border border-solid border-gray-30 bg-[#fff] active:!bg-gray-30'
        : 'bg-gray-10 active:!opacity-[0.4]',
      className
    )}
    {...props}
  />
);
